import { lazy } from "react";

const routes = [
  {
    path: "/pageOrgMapping",
    element: lazy(
      () => import("../../pages/ModulePersonalization/PageOrgMapping"),
    ),
  },
  {
    path: "/pageOrgMapping/create",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/PageOrgMapping/create-editPageOrgMapping"),
    ),
  },
  {
    path: "/pageOrgMapping/edit/:id",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/PageOrgMapping/create-editPageOrgMapping"),
    ),
  },
];

export default routes;
